import React from 'react';
import Blogs from '../Home/Blogs/Blogs';
import Work from '../Work/Work';
import HeaderMain from './HeaderMain/HeaderMain';
import Navbar from './Navbar/Navbar';
import HomeContact from '../Home/HomeContact/HomeContact';
import Footer from '../Footer/Footer';
import Particles from "react-particles-js";
import { particlesOptions } from "../../particlesOptions";
import "./Header.css";

const Header = () => {

    return (
        <>
            <div className="parti">
                <Particles
                    className="particles particles-box"
                    params={particlesOptions}
                />
            </div>
            <div className="home-sec">
                <Navbar></Navbar>
                <div style={{ position: "relative" }}>

                    <HeaderMain></HeaderMain>
                </div>
                <Work></Work>
                <Blogs></Blogs>
                <HomeContact></HomeContact>
                <Footer></Footer>
            </div>
        </>
    );
};

export default Header;